import React,{Component} from 'react';
import {reduxForm} from 'redux-form';
import * as actions from '../../actions';
import { Link, browserHistory } from 'react-router';
import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

class Otpverify extends Component{
  constructor(props){
    super(props);
    this.state={
      mobile: localStorage.mobile_number,
    }
    this.resendOtp = this.resendOtp.bind(this);
  }

  // componentWillMount(){
  //   this.props.clear_state();
  // }
    resendOtp(){
    var data1= {from:'mobile_web',mobile: this.state.mobile};
    var data2= JSON.stringify(data1);

    $.ajax({
      method: 'POST',
      url: baseUrl+'resendOtp',
      data: {req:data2},
      dataType: 'json',
      success: function(data){
        
      },
      error: function(err){
       
      }
    });
  }
componentDidMount(){
  this.refs.otp_input.focus();
}
handleFormSubmit(formProps){
    //this.props.Otpverify(formProps);    

      var mobile='';
      if(localStorage.mobile_number){
        mobile=localStorage.getItem('mobile_number');
      }
      else if(localStorage.mobile){
        mobile=localStorage.getItem('mobile');
      }
      var pwd = localStorage.getItem('pwd');
      var data1={from:'mobile_web',mobile: mobile,otp:formProps.otp, pwd: pwd}; 
      var data2 = JSON.stringify(data1);
    if(formProps.otp){
    var button = $('.otp_v');
        button.html("loading...");
        button.prop("disabled",true);
            $.ajax({
              method: 'POST',
              url: baseUrl+'verifyOtp',
              dataType:'json',
              data: {req:data2},
              success: function(data){
                    button.html("verify");
                    button.prop("disabled",false);
                if(data.status === 'fail'){
                  $('#otp_err').text('Invalid verification code');
                }else
                if(data.status === 'success'){
            localStorage.removeItem('pwd');
            localStorage.setItem('token',data.user[0].token);
            localStorage.setItem('user_id',data.user[0].id);
            browserHistory.push('/');
            window.location.reload();
                }
            },
            error: function(err){
              button.prop("disabled",false);
              button.html("verify");          
              console.log("Error"+err);
            }
            });
      }
}
  render()
  {
      $('#otp_input').keyup(function() {
                $('#otp_err').text('');
      });
      const {handleSubmit,fields:{otp}} = this.props;
      return (
            <div className="user_form">
                <Link to={'/account'} className="back_icon"><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=" " /></i></Link>
                 <div className="container ot_p pag_cntnt">
                   <div className="row" style={{marginLeft:'0',marginRight:'0'}}>
                      <h5 className="sign_in_title">Verify Your Mobile Number</h5>
                     <span className="otp_number">OTP sent to +91 {this.state.mobile}</span>
                      <form className="text-center otp_form" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                         <div className="reg_group">
                            <input {...otp} type="text" id="otp_input" required ref="otp_input" placeholder="Enter OTP"/>
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <span style={{color:'red',fontSize:'11px'}} id="otp_err"></span>
                         </div>
                         <div className="clr">&nbsp;</div>
                         <button action="submit" className="btn mob_regbtn">VERIFY</button>
                         <div className="clr">&nbsp;</div>
                          <div className="tap" >
                            <a style={{cursor:'pointer'}} onClick={this.resendOtp}>RESEND OTP</a>
                          </div>
                      </form>
                   </div>
                 </div> 
            </div>
      );
 }

}

function validate(formProps){
const errors = {};

return errors;
}

function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    formdata:state.auth.formdata
  };
}

export default reduxForm({
  form :'Otpverify',
  fields:['otp'],
  validate:validate

},mapStateToProps,actions)(Otpverify);


/** WEBPACK FOOTER **
 ** ./src/components/Auth/Otpverify.js
 **/